export default __webpack_public_path__ + "static/media/13.c97c0451.png";